export const subscriptionTypes = {
  HomeyDeveloperAthom: "homey_developer_athom",
  HomeyPlusAthom: "homey_plus_athom",
  HomeyPlusMonthlyApple: "homey_plus_monthly_apple",
  HomeyPlusMonthlyGoogle: "homey_plus_monthly_google",
  HomeyPremiumMonthlyApple: "homey_premium_monthly_apple",
  HomeyPremiumMonthlyGoogle: "homey_premium_monthly_google",
  HomeySelfHostedServersMonthly: "homey_self_hosted_server_monthly",
}